import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Form, Input, Select, Button, Space } from "antd";

import Sidebar from "../../../components/AdminComponents/SideNav";
import { SettingsMenu } from "../../../components/AdminComponents/MenuItems";
import Axios from "../../../api/Axios";
import { message } from "antd";
import {
  TrademarkOutlined,
  BackwardOutlined,
  SaveOutlined,
} from "@ant-design/icons";

import SecondaryNav from "../../../components/AdminComponents/SecondaryNav2";
import { capitalizeWords } from "../../../components/icons/ApplicationColor";
const { Option } = Select;

const ModuleRolesAdd = () => {
  const [messageApi, contextHolder] = message.useMessage();
  const formRef = useRef();
  const handleReset = () => {
    formRef.current.resetFields();
  };
  // eslint-disable-next-line no-unused-vars
  const [displayApps, setDisplayApps] = useState([]);
  const displayApplications = async () => {
    try {
      const res = await Axios.get(`/globaluserappaccess/`, {
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });
      //console.log(res);
      setDisplayApps(res.data);
    } catch (err) {
      //console.log(err);
    }
  };
  useEffect(() => {
    displayApplications();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  function getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
      const [cookieName, cookieValue] = cookies[i].split("=");
      if (cookieName === name) {
        return cookieValue;
      }
    }
    return null;
  }
  const csrfToken = getCookie("csrftoken");
  //console.log(csrfToken);
  const onFinish = async (values) => {
    //console.log(values);

    try {
      await Axios.post("/rolecreate/", values, {
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });
      //console.log(res);
      CreateSuccessfull();
    } catch (err) {
      //console.log(err);
      CreateFailed();
    }
  };
  const CreateSuccessfull = () => {
    messageApi.open({
      type: "success",
      content: "New Role has been created.",
      duration: 5,
    });
    setTimeout(() => {
      history(`/access-manager/roles`);
    }, 4000);
  };

  const CreateFailed = () => {
    messageApi.open({
      type: "error",
      content: "Role has not been Created.",
      duration: 5,
    });
  };
  const history = useNavigate();
  const thirdMenuData = [
    {
      path: `/access-manager/roles`,
      name: "Add Roles",
      icon: (
        <TrademarkOutlined
          style={{ fontSize: "15.5px", marginRight: "5px", margintop: "1px" }}
        />
      ),
    },
  ];
  return (
    <div className="page-scroller">
      <Sidebar props={SettingsMenu}>
        {contextHolder}

        <SecondaryNav menuItems={thirdMenuData} />
        <div className="form-container">
          <Form
            name="complex-form"
            onFinish={onFinish}
            layout="vertical"
            ref={formRef}
            labelCol={{
              span: 14,
            }}
            wrapperCol={{
              span: 16,
            }}
            style={{
              Width: "100%",
            }}
          >
            <div className="group1">
              <div className="form-heading">
                {" "}
                {capitalizeWords("ADD NEW ROLE")}
              </div>
              <div className="group-1-box">
                <div style={{ display: "inline-block" }}>
                  <Form.Item label={<p className="my-form-lables">Role ID</p>}>
                    <Space>
                      <Form.Item
                        name="role_id"
                        noStyle
                        rules={[
                          { required: true, message: "ID is required" },
                          {
                            pattern: /^[a-zA-Z0-9]*$/,
                            message:
                              "Please enter alphanumeric characters only",
                          },
                        ]}
                      >
                        <Input
                          className="my-form-input"
                          placeholder={
                            //   errors.username
                            //     ? `${errors.username}`
                            //     :
                            "Enter role ID"
                          }
                        />
                      </Form.Item>
                    </Space>
                  </Form.Item>
                </div>
                <div style={{ display: "inline-block", marginLeft: "2rem" }}>
                  <Form.Item
                    label={<p className="my-form-lables">Role Name</p>}
                  >
                    <Space>
                      <Form.Item
                        name="name"
                        noStyle
                        rules={[
                          { required: true, message: "name is required" },
                        ]}
                      >
                        <Input
                          className="my-form-input"
                          placeholder="Enter role name"
                        />
                      </Form.Item>
                    </Space>
                  </Form.Item>
                </div>
              </div>
              <div className="group-1-box" style={{ paddingTop: "1rem" }}>
                <div style={{ display: "inline-block" }}>
                  <Form.Item
                    label={<p className="my-form-lables">User Group</p>}
                  >
                    <Input.Group compact>
                      <Form.Item
                        name="user_group"
                        noStyle
                        initialValue={"TRAINERY"}
                      >
                        <Select
                          placeholder="Select Group"
                          className="my-form-input"
                        >
                          <Option value="TRAINERY">TRAINERY</Option>
                          <Option value="CLIENT">CLIENT</Option>
                        </Select>
                      </Form.Item>
                    </Input.Group>
                  </Form.Item>
                </div>

                <div style={{ display: "inline-block", marginLeft: "2rem" }}>
                  <Form.Item label={<p className="my-form-lables">Scope</p>}>
                    <Input.Group compact>
                      <Form.Item name="scope" noStyle initialValue={"GLOBAL"}>
                        <Select
                          placeholder="Select scope"
                          className="my-form-input"
                        >
                          <Option value={"GLOBAL"}>GLOBAL</Option>
                          <Option value={"APP"}>APP</Option>
                        </Select>
                      </Form.Item>
                    </Input.Group>
                  </Form.Item>
                </div>
              </div>
              <div className="group-1-box" style={{ paddingTop: "1rem" }}>
                <div style={{ display: "inline-block" }}>
                  <Form.Item
                    label={<p className="my-form-lables">Applications</p>}
                  >
                    <Input.Group compact>
                      <Form.Item
                        name={"applications"}
                        noStyle
                        rules={[
                          {
                            required: true,
                            message: "application is required",
                          },
                        ]}
                      >
                        <Select
                          placeholder="Select Application"
                          className="my-form-input"
                          mode="multiple"
                          style={{ width: "50rem" }}
                        >
                          {displayApps?.map((app) => (
                            <Option key={app.id} value={app.id}>
                              {app.name}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Input.Group>
                  </Form.Item>
                </div>
              </div>
            </div>

            <div style={{ display: "inline-block", marginLeft: "5rem" }}>
              <Form.Item label=" " colon={false}>
                <Button
                  type="text"
                  htmlType="button"
                  style={{
                    background: "#D3D3D3",
                  }}
                  onClick={() => {
                    history(`/access-manager/roles`);
                  }}
                >
                  <BackwardOutlined />
                  Back
                </Button>
              </Form.Item>
            </div>

            <div style={{ display: "inline-block", marginLeft: "16px" }}>
              <Form.Item label=" " colon={false}>
                <Button type="primary" htmlType="button" onClick={handleReset}>
                  Reset
                </Button>
              </Form.Item>
            </div>
            <div style={{ display: "inline-block", marginLeft: "16px" }}>
              <Form.Item label=" " colon={false}>
                <Button
                  type="primary"
                  htmlType="submit"
                  // className="my-form-input-end"
                  style={{
                    background: "#f58029",
                    fontWeight: "600",
                  }}
                  className="save-update-btn"
                >
                  Save
                  <SaveOutlined />
                </Button>
              </Form.Item>
            </div>
          </Form>
        </div>
      </Sidebar>
    </div>
  );
};

export default ModuleRolesAdd;
